import originalSwal from "sweetalert";
import { toast } from "sonner";

const GENERIC_TITLES = new Set([
  "success",
  "error",
  "oops!",
  "oops",
  "warning",
  "info",
  "completed",
  "partially completed",
]);

function showToast(title, text, type) {
  const heading = String(title || "").trim();
  const body = String(text || "").trim();
  const message = body || heading || "Done";
  const useDescription =
    Boolean(heading && body) && !GENERIC_TITLES.has(heading.toLowerCase());
  const options = useDescription ? { description: body } : undefined;
  const content = useDescription ? heading : message;

  if (type === "success") toast.success(content, options);
  else if (type === "error") toast.error(content, options);
  else if (type === "warning") toast.warning(content, options);
  else toast(content, options);

  return Promise.resolve(true);
}

function isConfirmDialog(options) {
  if (!options || typeof options !== "object") return false;
  if (options.buttons != null) return true;
  if (options.dangerMode) return true;
  if (options.closeOnClickOutside === false) return true;
  return false;
}

export default function swal(first, second, third) {
  if (typeof first === "object" && first !== null) {
    if (isConfirmDialog(first)) {
      return originalSwal(first);
    }

    const icon = first.icon || first.type || "info";
    return showToast(first.title, first.text, icon);
  }

  if (typeof third === "string" || typeof second === "string") {
    return showToast(first, typeof second === "string" ? second : "", third || "info");
  }

  return originalSwal(first, second, third);
}
